import React, { useCallback, useEffect, useRef, memo } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../utils/connectOptions';
import { isDeepChanged } from '../utils/ChangeSpy';
import { RedirectForceContext } from '../contexts/RedirectForceContext';

/**
 * Wrapper that adds beforeUpload reaction. If has some changes in state
 * will display a dialogue about unsaved changes.
 */
const UnloadWrapper = ({ children, appState }) => {
  const appStateRef = useRef(appState);

  useEffect(() => {
    appStateRef.current = appState;
  }, [appState]);

  const beforeUnload = useCallback(
    event => {
      if (!isDeepChanged(appStateRef.current)) return;

      const dialogText = 'You did not save some data. Should reload?';

      event.returnValue = dialogText;

      return dialogText;
    },
    [appStateRef],
  );

  useEffect(() => {
    window.addEventListener('beforeunload', beforeUnload);

    return () => {
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [beforeUnload]);

  const redirectForce = useCallback(
    location => {
      window.removeEventListener('beforeunload', beforeUnload);
      window.location = location;
    },
    [beforeUnload],
  );

  return (
    <RedirectForceContext.Provider value={redirectForce}>
      <div className="full-height">{children}</div>
    </RedirectForceContext.Provider>
  );
};

/**
 * Map application's state to appState property.
 *
 * @param state {Object} Application's state.
 */
function mapStateToProps(state) {
  return {
    appState: state,
  };
}

export { UnloadWrapper };
export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(UnloadWrapper));
